'use client';
import UKDialog from '@/components/UKDialog';
import CloseIcon from '@mui/icons-material/Close';
import { DialogContent, DialogTitle, IconButton } from '@mui/material';
import { styled } from '@mui/system';
import { useEffect, useState } from 'react';
import styles from './benefitDialog.module.scss';

interface mindItem {
  serviceTitle: string;
  serviceContent: string;
}

interface BenefitProp {
  open: boolean;
  title: string;
  mindList: mindItem[];
  closeFn: () => void;
}

const CustomerDialogContent = styled(DialogContent)({
  padding: '0 24px',
  marginBottom: '24px',
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#fff',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'rgba(0, 0, 0, 0.14)',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.28)',
  },
});

const BenefitDialog = ({ open, title, mindList, closeFn }: BenefitProp) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(open);
  }, [open]);

  const handleClose = () => {
    setIsOpen(false);
    closeFn && closeFn();
  };

  return (
    <UKDialog
      open={isOpen}
      onClose={handleClose}
      showCloseBtn={false}
      sx={{
        '& .MuiDialog-paper': {
          width: '800px',
          height: '480px',
          maxWidth: 'none',
          borderRadius: '12px',
        },
      }}
    >
      <DialogTitle
        sx={{
          height: 68,
          fontSize: 20,
          padding: '0 24px',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        {title}
      </DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <CustomerDialogContent>
        <div className={styles.modelContent}>
          {mindList.map((item: mindItem, index: number) => {
            return (
              <div className={styles.modelItem} key={index}>
                <div className={styles.subTitle}>{item?.serviceTitle}</div>
                {item?.serviceContent && (
                  <div
                    className={styles.richText}
                    dangerouslySetInnerHTML={{ __html: item.serviceContent }}
                  />
                )}
              </div>
            );
          })}
        </div>
      </CustomerDialogContent>
    </UKDialog>
  );
};

export default BenefitDialog;
